import { render, staticRenderFns } from "./KorzinkaIcon.vue?vue&type=template&id=e8683b62"
import script from "./KorzinkaIcon.vue?vue&type=script&lang=js"
export * from "./KorzinkaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports